import { Button, Divider, Popover, Typography } from "@payping/web-components";
import { SyncOutlined } from "@payping/icons";
import { FC } from "react";

import styles from "../../../assets/scss/NewVersion.module.scss";
import { useAppTranslation } from "../../../utils/useAppTranslation";

const NewVersionModal: FC = () => {
  const { t } = useAppTranslation();

  // const translationVersion = changeLog[0].version.replace(/\./g, "-");
  // const changes = t(`releaseNotes.${translationVersion}.features`, { returnObjects: true }).map(
  //   (_: string, i: number) => (
  //     <li key={i}>
  //       <Trans
  //         i18nKey={`Wrapper:releaseNotes.${translationVersion}.features.${i}`}
  //         components={(changeLog[0].links[i] || []).map((link: string, j: number) => (
  //           <Link key={j} to={link} />
  //         ))}
  //       />
  //     </li>
  //   )
  // );

  return (
    <Popover
      overlayClassName={styles.wrapper}
      content={
        <div>
          <div className={styles.versionRow}>
            <span>{t("version.currentVersion")}</span>
            <span>{process.env.REACT_APP_VERSION}</span>
          </div>
          {/* <div className={styles.versionRow}>
            <span>{t("version.newVersion")}</span>
            <span>1.1.1</span>
          </div> */}
          <Divider className={styles.divider} />
          <Typography.Text className="color--success">{t("version.updateProcess.title")}</Typography.Text>
          <Typography.Paragraph>{t("version.updateProcess.description")}</Typography.Paragraph>
          {/* <Typography.Text className="color--gray500">{t("version.newChanges")}</Typography.Text>
          <ul className={styles.list}>{changes}</ul> */}
        </div>
      }
    >
      <Button variant={"outline"} ghost icon={SyncOutlined}>
        {t("version.update")}
      </Button>
    </Popover>
  );
};

export default NewVersionModal;
